<template>
  <div class="filter-container">
    <b-row v-for="filter in value" :key="filter.level.levelId" class="mb-2">
      <b-col cols="12" xl="3" md="4" class="d-table">
        <span class="pl-3 align-middle d-table-cell">{{
          filter.level.levelCaption
        }}</span>
      </b-col>
      <b-col>
        <filter-date
          v-if="filter.level.levelDbType === 'DATE1'"
          :filter="filter"
          :selected-cube-id="selectedCubeId"
          @input="
            options => {
              changed(options, filter);
            }
          "
        />
        <filter-upload-file
          v-else-if="filter.level.levelDbType === 'AFFILIATECODE'"
          :selected-cube-id="selectedCubeId"
          :filter="filter"
          @input="
            options => {
              changed(options, filter);
            }
          "
        />
        <filter-member-code
            v-else-if="filter.level.levelDbType === 'MEMBERCODE'"
            :selected-cube-id="selectedCubeId"
            :filter="filter"
            @input="
            options => {
              changed(options, filter);
            }
          "
        />
        <filter-brand
            v-else-if="filter.level.levelDbType === 'BRAND'"
            :selected-cube-id="selectedCubeId"
            :filter="filter"
            @input="
            options => {
              changed(options, filter);
            }
          "
        />
        <filter-general
          v-else
          :selected-cube-id="selectedCubeId"
          :filter="filter"
          @input="
            options => {
              changed(options, filter);
            }
          "
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import _ from 'lodash';
import FilterDate from '@/components/datasets/FilterDate';
import FilterUploadFile from '@/components/datasets/FilterUploadFile';
import FilterMemberCode from "@/components/datasets/FilterMemberCode";
import FilterBrand from "@/components/datasets/FilterBrand";
import FilterGeneral from '@/components/datasets/FilterGeneral';

export default {
  name: 'FilterContainer',
  components: { FilterDate, FilterUploadFile, FilterMemberCode, FilterBrand, FilterGeneral },
  props: {
    value: {
      type: Array,
      required: true,
    },
    selectedCubeId: {
      type: Number,
      required: true,
    },
  },
  methods: {
    changed(options, filter) {
      const filters = _.cloneDeep(this.value);
      let thisFilter = _.find(filters, f => {
        return f.level.levelId === filter.level.levelId;
      });
      thisFilter.options = options;
      this.$emit('input', filters);
    },
  },
};
</script>

<style scoped>
.filter-container {
  font-size: 0.9em;
}
</style>